'use strict';

angular.module('docketbook')
  .controller('contactsController', function (addressBookService, xeroService, splitListInterface, $scope, $window, Restangular, $state, $stateParams, accessControl, uuid, $q) {
    mixpanel.track("Opened Contacts Desktop");

    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentState = $state.current;
    $scope.splitListFunc = new splitListInterface($scope, $stateParams);
    $scope.contactEdit = null;
    $scope.addressBook = [];
    $scope.selected = [];
    $scope.listCount = 50;
    $scope.extra = {};
    $scope.xeroContacts = [];
    $scope.filters = {
      search: "",
      tags: []
    };
    $scope.contactTagsSelected = [];
    $scope.contactEditTags = {
      add: [],
      delete: []
    }
    $scope.bulkTagAssignment = false;

    xeroService.getXeroContacts(function (contacts) {
      $scope.xeroContacts = contacts;
    }, function (err) {
      console.error('could not get xero contacts', err);
    });

    // New list query pagination
    $scope.query = {
      limit: 30,
      page: 1,
      order: 'displayName'
    };
    $scope.promise = null;

    $scope.goTo = function (href) {
      $window.location.href = href;
    }

    $scope.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };

    /*****************************/
    /***** Contact Functions *****/
    /*****************************/

    $scope.clearFilters = function () {
      $scope.filters = {
        search: "",
        tags: []
      }
    }

    $scope.closeContactTagSelectList = function () {
      $("#selectContactTagModal").fadeOut(100);
    }

    $scope.handleBulkTagAssignment = function () {
      const tagList = $scope.contactTagsSelected.map((tagObj) => {
        return tagObj.tag;
      })
      const promises = $scope.selected.map((contact) => {
        return $q(function (resolve, reject) {
          const updatePayload = {
            id: contact.id,
            tags: {
              add: tagList.filter((tag) => {
                return contact.tags.indexOf(tag) === -1
              })
            }
          };
          addressBookService.saveContact(updatePayload, function (contactUpdated) {
            resolve();
          }, function (err) {
            reject(err);
          })
        })
      })
      $q.all(promises).then(() => {
        $scope.bulkTagAssignment = false;
        $scope.loadTagList();
        $scope.closeContactTagSelectList();
      }).catch((err) => {
        $scope.bulkTagAssignment = false;
        $scope.loadTagList();
        $scope.closeContactTagSelectList();
      })
    }

    $scope.closeContactTagSelectListDone = function () {
      if ($scope.bulkTagAssignment) {
        $scope.handleBulkTagAssignment();
        return;
      }
      if (!$scope.contactEdit.tags) {
        $scope.contactEdit.tags = [];
      }
      $scope.contactTagsSelected.forEach((tagObj) => {
        const tag = tagObj.tag;
        if ($scope.contactEdit.tags.indexOf(tag) === -1) {
          $scope.contactEdit.tags.push(tag);
          $scope.contactEditTags.add.push(tag);
          if ($scope.contactEditTags.delete.indexOf(tag) !== -1) {
            $scope.contactEditTags.delete = $scope.contactEditTags.delete.filter((tag) => {
              return tag !== tag;
            })
          }
        }
      })
      $scope.closeContactTagSelectList();
    }

    $scope.removeTagFromContact = function (tag, contact) {
      contact.tags = contact.tags.filter((tag) => {
        return tag !== tag;
      })
      $scope.contactEditTags.delete.push(tag);
      if ($scope.contactEditTags.add.indexOf(tag) !== -1) {
        $scope.contactEditTags.add = $scope.contactEditTags.add.filter((tag) => {
          return tag !== tag;
        })
      }
    }

    $scope.addNewTags = function () {
      $scope.contactTagsSelected = [];

      $("#selectContactTagModal").fadeIn(100);
    }

    $scope.loadTagList = function () {
      $scope.loadPromise = $q(function (resolve, reject) {
        addressBookService.getAddressBookTags({}, function (results) {
          $scope.contactTagList = results;
          resolve($scope.allTags)
        }, function (err) {
          $scope.contactTagList = [];
          reject('Error');
        })
      })
    }

    $scope.startBulkTagAssignment = function () {
      $scope.bulkTagAssignment = true;
      $scope.addNewTags();
    }

    $scope.loadTagList();

    $scope.loadAddressBook = function () {
      $scope.promise = $q(function (resolve, reject) {
        var params = {};
        if ($scope.filters.search != null && $scope.filters.search != "") {
          params.search = $scope.filters.search;
        }
        if (($scope.filters.tags) && ($scope.filters.tags.length > 0)) {
          params.tags = $scope.filters.tags.map((tag) => {
            return tag.tag;
          }).join(',');
        }
        params['limit'] = $scope.query.limit;
        params['offset'] = $scope.query.limit * ($scope.query.page - 1);
        params['sort'] = $scope.query.order;
        addressBookService.getAddressBook(params, function (addressBookList) {
          var count = 0;
          if (params.offset <= 0 && addressBookList.length < params.limit) {
            count = addressBookList.length;
          } else {
            count = params.offset + (params.limit + 1);
          }
          $scope.listCount = count;
          $scope.addressBook = addressBookList;
          $scope.addressBook.forEach(function (contactItem) {
            var existingXeroContact = null;
            if (contactItem.externalIdentifiers) {
              contactItem.externalIdentifiers.forEach(function (eid) {
                if (eid.type === 'xero') {
                  existingXeroContact = eid;
                }
              })
            }
            if (existingXeroContact) {
              contactItem.xeroContact = existingXeroContact;
            }
          });
          addressBookService.getContactShares(null, function (contactSharesList) {
            $scope.addressBookShares = contactSharesList;
            resolve('Done');
          }, function (err) {
            resolve('Done');
          });
        }, function (err) {
          reject('Error');
        });
      });
    }

    $scope.loadAddressBook();

    $scope.newContact = function () {
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.contactEdit = { editing: true, displayName: '', addresses: [], contactAddresses: [{ emailAddress: '', accessLevel: 'viewer' }], initials: "NC", tags: [] };
      $scope.contactEditTags = {
        add: [],
        delete: []
      }
    }

    $scope.openContact = function (contact) {
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.contactEdit = angular.copy(contact);
      $scope.contactEditTags = {
        add: [],
        delete: []
      }
      // get address to edit
      if ($scope.contactEdit.addresses != null && $scope.contactEdit.addresses[0] != null) {
        $scope.contactEdit.address = $scope.contactEdit.addresses[0];
      } else {
        $scope.contactEdit.address = {};
      }

      // get shares sent
      if ($scope.contactEdit.contactAddresses && $scope.contactEdit.contactAddresses.length > 0) {
        var recipientsEmails = [];
        for (var i = 0; i < $scope.contactEdit.contactAddresses.length; i++) {
          recipientsEmails.push($scope.contactEdit.contactAddresses[i].emailAddress);
        }
        recipientsEmails.join(',');
        addressBookService.getContactShares({ direction: 'sent', recipients: recipientsEmails }, function (contactSharesSent) {
          if (contactSharesSent && contactSharesSent.length > 0) {
            $scope.contactEdit.shareSent = true;
          } else {
            $scope.contactEdit.shareSent = false;
          }
        }, function (err) {
          $scope.contactEdit.shareSent = false;
        });
      }

      var existingXeroIdentifier = $scope.contactEdit.externalIdentifiers.find(function (eid) {
        return eid.type === 'xero';
      });
      if (existingXeroIdentifier) {
        $scope.contactEdit.xeroID = existingXeroIdentifier.externalId;
      }
      if ($scope.contactEdit.xeroID != null) {
        // find full xero contact from list
        $scope.contactEdit.xeroContact = $scope.xeroContacts.find(function (contact) {
          return contact.externalId == $scope.contactEdit.xeroID;
        })
      }
    }

    $scope.openContactShare = function (contactShare) {
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.contactEdit = angular.copy(contactShare);
      $scope.contactEdit.fromShare = contactShare;
      delete $scope.contactEdit.id;

      // get address to edit
      if ($scope.contactEdit.addresses != null && $scope.contactEdit.addresses[0] != null) {
        $scope.contactEdit.address = $scope.contactEdit.addresses[0];
      } else {
        $scope.contactEdit.address = {};
      }
      $scope.contactEdit.editing = true;
      var contactAddressesFull = [];
      for (var i = 0; i < $scope.contactEdit.contactAddresses.length; i++) {
        var newContact = { emailAddress: $scope.contactEdit.contactAddresses[i], accessLevel: 'viewer' };
        contactAddressesFull.push(newContact);
      }
      $scope.contactEdit.contactAddresses = contactAddressesFull;
    }

    $scope.closeContact = function () {
      $scope.contactEdit = null;
      $scope.splitListFunc.slideTableListDetailClosed();
    }

    $scope.editContact = function (contact) {
      contact.editing = true;
    }

    $scope.addNewContactEmail = function (contact) {
      if (contact.contactAddresses == null) {
        contact.contactAddresses = [];
      }

      contact.contactAddresses.push({ emailAddress: "", accessLevel: "viewer" });
    }

    $scope.removeEmailFromContact = function (email, contact) {
      var index = contact.contactAddresses.indexOf(email);
      if (index != -1) {
        contact.contactAddresses.splice(index, 1);
      }
    }

    var validateContact = function (contact) {
      var validationErrors = [];
      // check displayName is provided
      if (!contact.displayName || contact.displayName == '') {
        validationErrors.push('Display Name is required');
      }
      // check email addresses are not blank
      if (contact.contactAddresses && contact.contactAddresses.length > 0) {
        for (var i = contact.contactAddresses.length - 1; i >= 0; i--) {
          if (contact.contactAddresses[i]) {
            if (contact.contactAddresses[i].emailAddress == '') {
              // remove this contactAddress
              contact.contactAddresses.splice(i, 1);
            } else {
              // check if is an emailAddress or a mobile number
              var thisEmail = contact.contactAddresses[i].emailAddress;
              var isEmail = false;
              var isMobile = false;
              var numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
              if (thisEmail.indexOf('@') != -1 && thisEmail.indexOf('.') != -1) {
                isEmail = true;
              }
              if (thisEmail.length == 10) {
                var foundNotANumber = false;
                for (var j = 0; j < thisEmail.length; j++) {
                  if (numbers.indexOf(thisEmail[j]) == -1) {
                    foundNotANumber = true;
                    break;
                  }
                }
                if (!foundNotANumber) {
                  isMobile = true;
                }
              }
              if (!isEmail && !isMobile) {
                validationErrors.push(thisEmail + ' is not an Email Address or Mobile Number');
              }
            }
          }
        }
      }

      //  check address has all required fields
      var otherFields = ['num', 'streetNum'];
      var requiredFields = ['streetName', 'suburb', 'state', 'postCode', 'country'];
      var niceDisplay = { 'streetName': 'Street Name', 'suburb': 'Suburb', 'state': 'State', 'country': 'Country', 'postCode': 'Post Code' };
      var addressPartComplete = false;
      var requiredFieldMissing = false;
      var fieldsMissing = [];
      if (contact.address) {
        for (var i = 0; i < otherFields.length; i++) {
          if (contact.address[otherFields[i]] != null && contact.address[otherFields[i]] != '') {
            addressPartComplete = true;
            break;
          }
        }
        for (var i = 0; i < requiredFields.length; i++) {
          if (contact.address[requiredFields[i]] == null || contact.address[requiredFields[i]] == '') {
            requiredFieldMissing = true;
            fieldsMissing.push(niceDisplay[requiredFields[i]]);
          } else {
            addressPartComplete = true;
          }
        }
      }

      if (addressPartComplete && requiredFieldMissing) {
        validationErrors.push('Address is missing some required fields - ' + fieldsMissing.join(', '));
      }

      if (validationErrors.length > 0) {
        $scope.alertService.presentAlert('warning', 'Invalid Fields', validationErrors.join('\n'));
        return false;
      } else {
        return true;
      }
    }

    $scope.saveContact = function (con) {
      if (!validateContact(con)) {
        return false;
      }
      let contact = Object.assign({}, con);
      contact.loading = true;
      // re-format addresses array
      // identify if address is empty or not
      var contactAddressKeys = [];
      if (contact.address) {
        contactAddressKeys = Object.keys(contact.address);
      }
      if (contact.id != null) {
        if ((contact.addresses == null || contact.addresses.length <= 0) && (contact.address && contactAddressKeys.length > 0)) {
          contact.addresses = { 'add': [] };
          contact.addresses.add.push(contact.address);
        } else if (contact.address && contactAddressKeys.length > 0) {
          contact.addresses = { 'update': [] };
          contact.addresses.update.push(contact.address);
        } else {
          delete contact.addresses;
        }
        contact.tags = $scope.contactEditTags;
      } else {
        if (contact.address) {
          contact.addresses = [];
          contact.addresses.push(contact.address);
        }
      }
      if (contact.xeroID && contact.id != null) {
        var existingXeroIdentifier = null;
        if (contact.externalIdentifiers) {
          existingXeroIdentifier = contact.externalIdentifiers.find(function (eid) {
            return eid.type === 'xero';
          });
        }
        if ((!contact.externalIdentifiers) || (existingXeroIdentifier === undefined) || (existingXeroIdentifier === null) || (existingXeroIdentifier.externalId !== contact.xeroID)) {
          contact.externalIdentifiers = {
            add: [{
              type: 'xero',
              externalId: contact.xeroID
            }]
          };
          if (existingXeroIdentifier !== undefined) {
            contact.externalIdentifiers.remove = [existingXeroIdentifier];
          }
        }
      } else if (contact.xeroID && contact.id == null) {
        contact.externalIdentifiers = [];
        contact.externalIdentifiers.push({
          type: 'xero',
          externalId: contact.xeroID
        });
      }

      addressBookService.saveContact(contact, function (contactUpdated) {
        // if contact is being created from a share - delete the share first
        if (contact.fromShare != null) {
          addressBookService.deleteContactShare(contact.fromShare, function (success) {
            $scope.loadAddressBook();
            $scope.openContact(contactUpdated);
          }, function () {
            $scope.loadAddressBook();
            $scope.contactEdit = null;
          });
        } else {
          $scope.loadAddressBook();
          $scope.openContact(contactUpdated);
        }
      }, function (err) {
        contact.loading = false;
        $scope.alertService.presentAutoAlert('saveContact', err);
      });
    }

    // Remove a contact
    $scope.removeContact = function (contact) {
      addressBookService.deleteContact(contact, function (success) {
        $scope.loadAddressBook(true);
        $scope.closeContact();
      }, function (err) {
        $scope.alertService.presentAutoAlert('deleteContact', err);
      });
    }

    // Remove selected contacts
    $scope.deleteSelectedContacts = function () {
      swal({
        title: "Are you sure?",
        text: "Do you really want to delete these contacts?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          addressBookService.deleteBulkContacts($scope.selected, function (failures) {
            if (failures && failures.length > 0) {
              swal("Oops", failures.length + " of " + $scope.selected.length + " contacts could not be deleted.", "warning");
              $scope.loadAddressBook(true);
            } else {
              $scope.loadAddressBook(true);
              $scope.selected = []
            }
          });
        }
      });
    }



    /**************************/
    /***** Contact Shares *****/
    /**************************/

    $scope.newContactShare = function (shareWith) {
      $scope.shareEdit = {};
      $scope.shareEdit.displayName = $scope.currentOrgGroup.publicName;
      $scope.shareEdit.contactAddresses = $scope.currentOrgGroup.emailAddresses;
      var newContactAddresses = [];
      for (var i = 0; i < $scope.shareEdit.contactAddresses.length; i++) {
        var newContact = { id: uuid.v4(), emailAddress: $scope.shareEdit.contactAddresses[i] };
        newContactAddresses.push(newContact);
      }
      $scope.shareEdit.contactAddresses = newContactAddresses;
      var groupAddress = $scope.currentOrgGroup.address;
      if (groupAddress) {
        $scope.shareEdit.address = groupAddress;
      }
      if (shareWith) {
        $scope.shareEdit.shareWith = shareWith;
        if (shareWith.contactAddresses.length == 1) {
          $scope.shareEdit.recipient = shareWith.contactAddresses[0].emailAddress;
        }
      }
      // setup comment
      var comment = "Hi there,\n\nI would like to connect with you on docketbook.\nMy latest contact details are here!\n\nCheers, " + $scope.currentUser.name.first;
      $scope.shareEdit.comment = comment;
      $("#shareContactModal").fadeIn(100);
    }

    $scope.closeNewShareModal = function () {
      $("#shareContactModal").fadeOut(100);
    }

    $scope.saveShare = function (share) {
      share.loading = true;
      share.addresses = [];
      share.addresses.push(share.address);

      var newContactAddresses = [];
      for (var i = 0; i < share.contactAddresses.length; i++) {
        if (share.contactAddresses[i].emailAddress != null && share.contactAddresses[i].emailAddress != "") {
          newContactAddresses.push(share.contactAddresses[i].emailAddress);
        }
      }
      share.contactAddresses = newContactAddresses;

      if (share.shareWith && share.shareWith.contactAddresses && share.shareWith.contactAddresses.length > 1) {
        // get list of addresses to send contact share to
        var emails = [];
        for (var i = 0; i < share.shareWith.contactAddresses.length; i++) {
          if (share.shareWith.contactAddresses[i].selected) {
            emails.push(share.shareWith.contactAddresses[i].emailAddress.toLowerCase());
          }
        }
        addressBookService.saveBulkContactShares(emails, share, function (failures) {
          $scope.loadAddressBook();
          $scope.shareEdit = null;
          $("#shareContactModal").fadeOut(100);

          if (failures && failures.length > 0) {
            swal("Oops.", failures.length + " of " + emails.length + " shares could not be sent.", "warning");
          }
        });
      } else {
        share.recipient = share.recipient.toLowerCase();
        addressBookService.saveContactShare(share, function (success) {
          $scope.loadAddressBook();
          if (share.shareWith) {
            $scope.contactEdit.shareSent = true;
          }
          $scope.shareEdit = null;
          $("#shareContactModal").fadeOut(100);
        }, function (err) {
          $scope.shareEdit.loading = false;
          $scope.alertService.presentAutoAlert('contactShare', err);
        });
      }
    }

    $scope.addNewShareEmail = function (share) {
      if (share.contactAddresses == null) {
        share.contactAddresses = [];
      }

      var newBlankContact = { id: uuid.v4(), emailAddress: "" };
      share.contactAddresses.push(newBlankContact);
    }

    /****** Validate Contact Emails *******/
    $scope.validateContactEmails = function (contact) {
      if (contact.contactAddresses == null || contact.contactAddresses.length <= 0) {
        return false;
      }
      for (var i = 0; i < contact.contactAddresses.length; i++) {
        if (contact.contactAddresses[i].emailAddress == null || contact.contactAddresses[i].emailAddress == "") {
          return false;
        }
      }
      return true;
    }

    /******* Xero Contact Syncing *******/
    $scope.syncXeroContact = function (contactFor) {
      $scope.xeroContactSelectFromParent(function (contactSelected) {
        if (contactSelected != null) {
          if (!$scope.contactEdit.editing) {
            $scope.contactEdit.editing = true;
          }
          $scope.contactEdit.xeroID = contactSelected.externalId;
          $scope.contactEdit.xeroContact = contactSelected;
        }
      });
    }


    /**** Filters *****/
    $scope.$watch('filters', function () {
      $scope.loadAddressBook();
    }, true);


    $scope.userIsXeroAuthenticated = function () {
      if (!$scope.currentUser.xeroAuthentication) {
        return false;
      }
      if (!$scope.currentUser.xeroAuthentication.authenticatedUntil) {
        return false;
      }
      if (moment($scope.currentUser.xeroAuthentication.authenticatedUntil).isBefore(moment())) {
        return false;
      }
      return true;
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/contacts.js